// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__2eUxP","primary":"Button_primary__2r3_u","filled":"Button_filled__3lJd-","secondary":"Button_secondary__22PAj","outlined":"Button_outlined__3zBNP"};